import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert,
  Checkbox,
  Tooltip
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import DatePicker from "react-date-picker";
import moment from 'moment';
// import "react-datepicker/dist/react-datepicker.css";
import CKEditor from "react-ckeditor-component";
import { bindActionCreators, compose } from "redux";
import "../../style/announcements/AddAnnouncements.scss";
import {
  addAnnouncements,
  getAnnouncementsDetails,
  updateAnnouncements,
  getSiteList
} from "../../redux/actions/announcementsActions";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../components";
import isEmpty from "lodash.isempty";
import loader from "../../style/loader/loader.scss";
import Picky from "react-picky";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
const history = createHashHistory();

class AddAnnouncements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      announcementsID: "",
      title: "",
      description: "",
      start_date: "",
      end_date: "",
      status: "active",
      displaySubadmin: 0,
      displayMerchant: 0,
      siteList: [],
      selectedSites: [],
      path: ["Home", "Announcements", "Add Announcements"],
      links: ["home","announcements","AddAnnouncements"],
      alertMessage: "",
      msgType: "",
      show: false,
      isLoading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSiteChange = this.handleSiteChange.bind(this);
  }

  onChangeStartDate = date => { this.setState({ start_date: date, startDateTimeError:""})};
  onChangeEndDate = date => { this.setState({ end_date: date, endDateTimeError:""})};

  handleSiteChange(event, data) {
    this.setState({
      selectedSites: event
    });
  }  

  componentWillMount(e) {
    let announcementsIdParams = this.props.match.params.announcementsId
      ? this.props.match.params.announcementsId
      : "";
    if (announcementsIdParams !== "") {
      const editLink = `AddAnnouncements/${announcementsIdParams}`
      this.props.getAnnouncementsDetails(announcementsIdParams);
      this.state.path = ["Home", "Announcements", "Edit Announcements"];
      this.state.links = ["home","announcements",editLink];
    }
    this.props.getSiteList({page: 0});
  }

  componentWillUnmount() {
    this.setState({ alertMessage: "", msgType: "", show: false });
  }

  componentWillReceiveProps(nextProps) {

    if (this.props.fetchAnnouncements !== nextProps.fetchAnnouncements) {
      this.setState({ isLoading: nextProps.fetchAnnouncements });
    }

    if(this.props.siteList !== nextProps.siteList){
      //console.log('nextProps.siteList',nextProps.siteList)
      if(nextProps.siteList){
        this.setState({
          sitedata: nextProps.siteList,
          siteList: nextProps.siteList
        })
      }
    } 

    if (
      this.props.announcementsDetails !== nextProps.announcementsDetails &&
      !isEmpty(nextProps.announcementsDetails)
    ) {
      this.setState({ announcementsDetailsForEdit: nextProps.announcementsDetails.data });
      let announcementsDetails = nextProps.announcementsDetails.data;
      //console.log('announcementsDetails', announcementsDetails.siteListID);
      this.setState({
        announcementsID: announcementsDetails.announcementsID,
        title: announcementsDetails.title,
        description: announcementsDetails.description,
        start_date: (announcementsDetails.start_date) ? new Date(moment(announcementsDetails.start_date).format('YYYY-MM-DD')) : "",
        end_date: (announcementsDetails.end_date) ? new Date(moment(announcementsDetails.end_date).format('YYYY-MM-DD')) : "",
        status: announcementsDetails.status,
        displaySubadmin: announcementsDetails.displaySubadmin,
        displayMerchant: announcementsDetails.displayMerchant,
        siteID: announcementsDetails.siteID,
        selectedSites: announcementsDetails.siteListID
      });
    }
    if (this.props.error !== nextProps.error) {
      this.setState({
        alertMessage: nextProps.error,
        msgType: "warning",
        show: true
      });
    }
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    if (e.target.name === "start_date" || e.target.name === "end_date") {
      this.setState({ endDateTimeError: "", startDateTimeError: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handleChangeContent = (evt) => {
    var newContent = evt.editor.getData();
    this.setState({
      description: newContent,
      descriptionError: ""

    });
  }

  displaySubadmin = e => {
    if (e.target.checked) {
      //console.log('e.target.checkedsubadmin',e.target.checked)
      this.setState({displaySubadmin: 1 });
    } else {
     // console.log('e.target.checkedsubadminelse',e.target.checked)
      this.setState({ displaySubadmin: 0 });
    }
  };

  displayMerchant = e => {
    if (e.target.checked) {
     // console.log('e.target.checkedmerchant',e.target.checked)
      this.setState({displayMerchant: 1 });
    } else {
     // console.log('e.target.checkedmerchantelse',e.target.checked)
      this.setState({ displayMerchant: 0 });
    }
  };

  editSource = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
      const editable = editor._.editable;
      editable.attachListener(editable, 'input', e => {
        this.handleChangeContent(mode)
      });
    }
  }

  handleValidation() {
    let formIsValid = true;
    this.state.titleError = false;
    this.state.startDateTimeError = false;
    this.state.endDateTimeError = false;
    this.state.descriptionError = false;
    if (!this.state.title) {
      formIsValid = false;
      this.setState({
        titleError: "Title Field is Required !"
      });
    }
    if (!this.state.start_date) {
      formIsValid = false;
      this.setState({
        startDateTimeError: "Start Date Field is Required !"
      });
    }
    if (!this.state.end_date) {
      formIsValid = false;
      this.setState({
        endDateTimeError: "End Date Field is Required !"
      });
    }
    if (!this.state.description) {
      formIsValid = false;
      this.setState({
        descriptionError: "Description Field is Required !"
      });
    }
    return formIsValid;
  }

  handleSubmit(e) {
    e.preventDefault();
    let seletedIDs = this.state.selectedSites.map((sVal, index) => sVal.siteID);
    if (this.handleValidation()) {
      if (this.state.announcementsID !== "") {
        const updateData = {
          announcementsID: this.state.announcementsID,
          title: this.state.title,
          description: this.state.description,
          start_date:this.state.start_date? moment(this.state.start_date).format("YYYY-MM-DD")
          : null,
          end_date: this.state.end_date? moment(this.state.end_date).format("YYYY-MM-DD")
          : null,
          status: this.state.status,
          displaySubadmin: this.state.displaySubadmin,
          displayMerchant: this.state.displayMerchant,
          siteID: seletedIDs
        };
        this.props.updateAnnouncements(updateData);
      } else if (this.state.announcementsID === "") {
        const postData = {
          title: this.state.title,
          description: this.state.description,
          start_date:this.state.start_date? moment(this.state.start_date).format("YYYY-MM-DD")
          : null,
          end_date: this.state.end_date? moment(this.state.end_date).format("YYYY-MM-DD")
          : null,
          status: this.state.status,
          displaySubadmin: this.state.displaySubadmin,
          displayMerchant: this.state.displayMerchant,
          siteID: seletedIDs
        };
        this.props.addAnnouncements(postData);
      }
    }
  }



  getValidationSDateState() {
    const sDate = moment(this.state.start_date).format("YYYY-MM-DD");
    const eDate = moment(this.state.end_date).format("YYYY-MM-DD");
    if (this.state.start_date && this.state.start_date) {
      if (sDate > eDate) return "error";
    }
    if (!this.state.start_date && this.state.end_date) return "error";

    return null;
  }

  getValidationEDateState() {
    const sDate = moment(this.state.start_date).format("YYYY-MM-DD");
    const eDate = moment(this.state.end_date).format("YYYY-MM-DD");
    if (this.state.end_date && this.state.start_date) {
      if (eDate < sDate) return "error";
    }
    if (!this.state.end_date && this.state.start_date) return "error";

    return null;
  }

  onStartDateTimeBlur = e => {
    e.preventDefault();
    const startDate = moment(this.state.start_date).format("YYYY-MM-DD");
    const endDate = moment(this.state.end_date).format("YYYY-MM-DD");
    if (this.state.endDateTime && this.state.start_date) {
      if (startDate > endDate) {
        this.setState({
          startDateTimeError: "Start date should be less than end date!"
        });
      }else{
        this.setState({
          startDateTimeError: ""
        });
      }
    }
  };
  onEndDateTimeBlur = e => {
    e.preventDefault();
    const startDate = moment(this.state.start_date).format("YYYY-MM-DD");
    const endDate = moment(this.state.end_date).format("YYYY-MM-DD");
    if (this.state.start_date && this.state.end_date) {
      if (startDate > endDate) {
        this.setState({
          endDateTimeError: "End date should be greater than start date!"
        });
      }else{
       this.setState({
        endDateTimeError: ""
      });
     }
   }
 };


  render() {
 
    let pageTitle = this.state.title ? "Edit Announcements" : "Add Announcements";
    //console.log('this.state.displayMerchant', this.state.displayMerchant);
    let siteListData = this.state.siteList
      ? this.state.siteList
      : [];

    const { siteList, selectedSites } = this.state;
    //console.log('this.state.selectedSites',this.state.selectedSites)
    let siteNamefromID = this.state.selectedSites.map((sVal, index) => sVal.siteName);  

    return (
      <div className="col-lg-12 add-announcements">
        <BreadcrumbComponent path={this.state.path} links={this.state.links}/>

        <div className="panel">
          <header className="panel-heading">{pageTitle}</header>
          <div className="panel-body">
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong className="alert-msg-type">
                      {this.state.msgType}:
                    </strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <div className="add-announcements col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <form onSubmit={this.handleSubmit}>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formBasicTitle">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span>Title
                      </ControlLabel>
                      <FormControl
                        type="text"
                        name="title"
                        value={this.state.title}
                        placeholder="Enter text"
                        onChange={this.handleChange}
                      />
                      {this.state.titleError && (
                          <Tooltip
                            placement="bottom"
                            className="in"
                            id="tooltip-bottom"
                          >
                            {this.state.titleError}
                          </Tooltip>
                        )}
                    </FormGroup>
      <FormGroup
                        controlId="formStartDateTime"
                        validationState={this.getValidationSDateState()}
                        onBlur={this.onStartDateTimeBlur.bind(this)}
                        >
                        <ControlLabel><span style={{color: "red"}}>*</span> Start Date:</ControlLabel><br/>
                        <DatePicker            
                          onChange={this.onChangeStartDate} 
                          value={(this.state.start_date) ? this.state.start_date : "" }                                                  
                        />
                        {this.state.startDateTimeError && (
                          <Tooltip
                            placement="bottom"
                            className="in"
                            id="tooltip-bottom"
                          >
                            {this.state.startDateTimeError}
                          </Tooltip>
                        )}
                    </FormGroup>

                  

               <FormGroup
                        controlId="formEndDateTime"
                        validationState={this.getValidationEDateState()}
                        onBlur={this.onEndDateTimeBlur.bind(this)}
                        >
                        <ControlLabel><span style={{color: "red"}}>*</span> End Date:</ControlLabel><br/>
                        <DatePicker            
                          onChange={this.onChangeEndDate} 
                          value={(this.state.end_date) ? this.state.end_date : "" }                                                  
                        />
                        {this.state.endDateTimeError && (
                          <Tooltip
                            placement="bottom"
                            className="in"
                            id="tooltip-bottom"
                          >
                            {this.state.endDateTimeError}
                          </Tooltip>
                        )}            
                    </FormGroup>
                    <FormGroup controlId="formBasicLongitude">
                      <ControlLabel>
                        Description
                      </ControlLabel>
                      <CKEditor
                          activeClass="p10"
                          content={this.state.description}
                          events={{
                            change: this.handleChangeContent,
                            blur: this.handleChangeContent,
                            afterPaste: this.handleChangeContent,
                            mode: this.editSource
                          }}
                        config={{allowedContent: true,versionCheck:false}}
                       
                        />
                      {this.state.descriptionError && (
                          <Tooltip
                            placement="bottom"
                            className="in"
                            id="tooltip-bottom"
                          >
                            {this.state.descriptionError}
                          </Tooltip>
                      )}
                    </FormGroup>
                    <FormGroup controlId="formStatus">
                      <ControlLabel>Status</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="status"
                        onChange={this.handleChange}
                        value={this.state.status}
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formSiteID">
                      <ControlLabel>Choose which site(s) the announcement</ControlLabel>     
                      <Picky
                        numberDisplayed={3}
                        options={siteList}
                        value={selectedSites}
                        valueKey="siteID"
                        labelKey="siteName"
                        multiple={true}
                        includeSelectAll={true}
                        includeFilter={true}
                        onChange={this.handleSiteChange}
                        dropdownHeight={200}
                      />
                    </FormGroup>             
                    <FormGroup controlId="formDisplaySubadmin"> 
                      <ControlLabel>Display Announcements option</ControlLabel>  
                      {(this.state.displaySubadmin == 1) ?             
                        <Checkbox
                          name="displaySubadmin"
                          defaultChecked={true}
                          key={Math.random()}
                          onChange={this.displaySubadmin}
                        >
                          Display in Subadmin Accounts
                        </Checkbox> 
                      :
                        <Checkbox
                          name="displaySubadmin"
                          key={Math.random()}
                          onChange={this.displaySubadmin}
                        >
                          Display in Subadmin Accounts
                        </Checkbox>
                      }
                    </FormGroup>
                    <FormGroup controlId="formDisplayMerchant">  
                      {(this.state.displayMerchant == 1) ?
                        <Checkbox
                          name="displayMerchant"
                          key={Math.random()}
                          defaultChecked={true}
                          onChange={this.displayMerchant}
                        >
                        Display in Merchant Portal
                        </Checkbox> 
                      :
                        <Checkbox
                          name="displayMerchant"
                          key={Math.random()}
                          onChange={this.displayMerchant}
                        >
                        Display in Merchant Portal
                        </Checkbox>  
                      }  
                   </FormGroup>                                     
                  </Col>
                  <Col md={6} xs={12}>
                    {this.state.isLoading ? (
                      <div className="loader">
                        <p className="loading-message">
                          <i>Loading...</i>
                        </p>
                        <div className="spinner">
                          <div className="dot1" />
                          <div className="dot2" />
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                  </Col>
                  <Col md={12} xs={12}>
                    <Button
                      bsStyle="primary"
                      disabled={this.props.sendingAnnouncementsData}
                      type="submit"
                    >
                      Submit
                    </Button>
                    <Button
                      bsStyle="default"
                      onClick={() => history.push(`/announcements`)}
                    >
                      Cancel
                    </Button>
                  </Col>
                </form>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AddAnnouncements.propTypes = {
  addAnnouncements: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  announcementsDetails: state.announcementsReducers.announcementsDetails,
  error: state.announcementsReducers.error,
  fetchAnnouncements: state.announcementsReducers.fetchAnnouncements,
  sendingAnnouncementsData: state.announcementsReducers.sendingAnnouncementsData,
  announcementsResponse: state.announcementsReducers.announcementsResponse,
  siteList: state.announcementsReducers.siteList,
  announcementsUpdate: state.announcementsReducers.announcementsUpdate
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    addAnnouncements,
    getAnnouncementsDetails,
    getSiteList,
    updateAnnouncements
  })
)(AddAnnouncements);



// WEBPACK FOOTER //
// ./src/app/views/announcements/AddAnnouncements.js